import { render } from "./CardProduct.vue?vue&type=template&id=a7339a56"
import script from "./CardProduct.vue?vue&type=script&lang=js"
export * from "./CardProduct.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__